// Shared dense spreadsheet-table class constants (see /app/design_guidelines.json).
// Import these instead of re-typing class strings so every module stays consistent.
export const DT = {
  wrap: "relative w-full overflow-x-auto rounded-md border border-slate-200 bg-white shadow-xs",
  table: "w-full border-collapse text-left text-xs text-slate-800",
  thead: "bg-slate-100/90 select-none",
  headerRow: "border-b border-slate-200",
  th: "px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-slate-600 text-left",
  thRight: "px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-slate-600 text-right",
  thCenter: "px-3 py-2 text-[10px] font-bold uppercase tracking-wider text-slate-600 text-center",
  row: "border-b border-slate-100 transition-colors duration-150 even:bg-slate-50/60 hover:bg-slate-100/80 group",
  td: "px-3 py-2 text-xs text-slate-800 align-middle",
  tdRight: "px-3 py-2 text-xs text-right font-mono-data text-slate-700 align-middle",
  stickyLeft: "sticky left-0 z-10 bg-inherit",
  stickyRight: "sticky right-0 z-10 bg-inherit",
  actionsCell: "flex items-center justify-end gap-1",
  iconBtn: "h-7 w-7 inline-flex items-center justify-center rounded text-slate-500 hover:text-slate-900 hover:bg-slate-200/70 transition-colors",
};
